import { View, Text as PDFText } from '@react-pdf/renderer'
import moment from 'moment-jalaali'

import styles from './styles/index.style'

interface HeaderProps {
  Created: string
  ReservationNumber: string
}

const Header = ({ ReservationNumber, Created }: HeaderProps) => {
  return (
    <View style={styles.mainDiv}>
      <View style={styles.rowDirection}>
        <PDFText style={styles.subjectValue}>
          {moment(Created).format('jYYYY/jMM/jDD HH:mm:ss')}
        </PDFText>
        <PDFText style={styles.subjectTitle}>زمان ثبت رزرو: </PDFText>
      </View>
      <View style={styles.imageContianer}>
        <View></View>
      </View>
      <View style={styles.rowDirection}>
        <PDFText style={styles.subjectValue}>{ReservationNumber}</PDFText>
        <PDFText style={styles.subjectTitle}>شماره رزرو: </PDFText>
      </View>
    </View>
  )
}
export default Header
